import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

Pusher.logToConsole = false

const isLoggedIn =
  document.documentElement.getAttribute('data-auth') === '1'

if (isLoggedIn) {
  window.Pusher = Pusher

  window.Echo = new Echo({
    broadcaster: 'pusher',
    key: import.meta.env.VITE_PUSHER_APP_KEY,
    cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
    forceTLS: true,
    encrypted: true,
    enabledTransports: ['ws', 'wss'],
    enableStats: true,
  })

  console.log('%cEcho Started ✅', 'color: #0f0')
} else {
  console.log('%cEcho Disabled (guest user) 🚫', 'color: #f00')
}
